import React from "react";
import { Card, PageContainer } from "../../components/ui";

const Dashboard = () => {
  return (
    <PageContainer>
      <Card>
        <div className="mx-auto max-w-screen-sm text-center py-8" />
      </Card>
    </PageContainer>
  );
};

export default Dashboard;
